import script from "./WImageProfile.vue?vue&type=script&lang=ts"
export * from "./WImageProfile.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__